// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"3c8c0ba0","434":"53effcfe"}[chunkId] + ".chunk.js";
};